import React from 'react';

import { useTranslation } from "react-i18next";

import footer from '../img/footer.png';

function Footer() {

  const { t } = useTranslation();

  return (
    <div className='z-10 relative pt-[80px] xl:pt-[140px]'>
      <div className='max-w-[1220px] mx-[20px] xl:mx-auto relative'>
        <div className='bg-[#2A323F] pb-[20px] flex flex-col items-center'> 
            <p className='text-center host-grotesk mt-[30px] text-white text-[14px] xl:text-[16px]'>{t('footer.4')}</p>
            <p className='text-white left-[35px] mt-[20px] text-[20px] text-center sm:text-[24px] md:text-[32px] xl:text-[48px] xl:max-w-[568px] leading-[1.2]'>{t('footer.1')}</p>
            <p className='mx-[20px] PtRoot mt-[70px] text-[#30C1F6] text-[12px] xl:text-[14px] font-[700]'>Support@auditandrecovery-consulting.com</p>
            <a href="/terms.pdf"><p className='pt-[12px] mx-[20px] text-[#FFFFFFB2] text-[12px] xl:text-[14px] PtRoot font-[700]'>{t('footer.5')}</p></a>
            <p className='pt-[40px] mx-[20px] text-[#FFFFFF80] text-[12px] xl:text-[14px] PtRoot text-center'>{t('footer.6')}</p>
        </div>
      </div>
     </div>
  );
}

export default Footer;